// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_Ueljg","breadcrumbs":"index_breadcrumbs_9Ynai"};